import React from "react";
import { CheckCircle2 } from "lucide-react";
import connectionModelImg from "../../../../assets/images/Landing_Page/connection_model.webp";
import { connectionDiscoverList } from "../data/content";

export default function ConnectionModel() {
  return (
    <section className="section-py">
      <div className="container text-center">
        <h2 className="section-title">The Connection Model</h2>
        <p className="section-subtitle mb-4">
          SELECTEZI expands the traditional buyer and seller relationship
          into a broader business network
        </p>

        <div className="diagram-wide">
          <div className="diagram-image-frame connection-model-image-frame">
            <img src={connectionModelImg} alt="The SELECTEZI Connection Model" />
          </div>
        </div>

        <div className="text-center mt-4">
          <a href="#" className="btn-selectezi-primary" style={{ background: "var(--blue-600)" }}>
            CREATE SHOWCASE &rarr;
          </a>
        </div>

        <div className="row g-4 mt-4 text-start">
          {[0, 1, 2].map((col) => (
            <div className="col-md-4" key={col}>
              <ul className="list-unstyled check-list">
                {connectionDiscoverList
                  .slice(col * 2, col * 2 + 2)
                  .map((line) => (
                    <li key={line}>
                      <CheckCircle2 size={18} />
                      <span>{line}</span>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
